// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#main-content{flex-grow:1;overflow:scroll;width:calc(100% - 16px)}#header-section{height:124px;z-index:99999;position:sticky}.sidebar-content{width:420px;min-width:420px;overflow:scroll;padding:10px}@media(max-width: 1300px){.sidebar{width:370px;min-width:370px}#header-section{height:124px}}", ""]);
// Exports
module.exports = exports;
